import { Button, useDataProvider, useNotify } from "react-admin";
import moment from "moment/moment";
import { FC } from "react";
import { uniq } from "lodash";
import {
  getBusAssistantName,
  getBusAssistantsByIds,
  getDriverName,
  getDriversByIds,
  getVehiclePlateNumber,
  getVehiclesByIds,
  processRoutesToRemoveSchoolLocation,
} from "../tools";

interface CopyRouteInTextButtonProps {
  selectedData: any;
  school: any;
  busSchedule: any;
}

const CopyRouteInTextButton: FC<CopyRouteInTextButtonProps> = ({
  selectedData,
  school,
  busSchedule,
}) => {
  const provider = useDataProvider();
  const notify = useNotify();

  const handleCopyToClipboard = async (route: any) => {
    const driverIds = uniq([
      ...[route.driverId],
      ...route.backupDrivers,
    ]).filter((id: number) => id != null);

    const busAssistantIds = uniq([
      ...[route.busAssistantId],
      ...route.backupBusAssistants,
    ]).filter((id: number) => id != null);

    const vehicleIds = uniq([
      ...[route.vehicleId],
      ...route.backupVehicles,
    ]).filter((id: number) => id != null);

    let drivers: any[] = [];
    let busAssistants: any[] = [];
    let vehicles: any[] = [];

    if (driverIds.length > 0) {
      drivers = await getDriversByIds(provider, driverIds);
    }

    if (busAssistantIds.length > 0) {
      busAssistants = await getBusAssistantsByIds(provider, busAssistantIds);
    }

    if (vehicleIds.length > 0) {
      vehicles = await getVehiclesByIds(provider, vehicleIds);
    }

    const schoolData = `School: ${school.name} \n ${school.address} \n\n`;

    const waveData =
      `${route.routeName}\n` +
      `Sch: ${school.name} \n` +
      `Start time: ${route.startTime} \n` +
      `End Time: ${route.endTime} \n\n`;

    const driverData =
      `Driver: ${
        route.driverId ? getDriverName(drivers, route.driverId) : "-"
      }, ${
        route.backupDrivers.map((id: any) => {
          return ` [${getDriverName(drivers, id)}]`;
        }) || ""
      } \n` +
      `BA: ${
        route.busAssistantId
          ? getBusAssistantName(busAssistants, route.busAssistantId)
          : "-"
      },${
        route.backupBusAssistants.map((id: any) => {
          return ` [${getBusAssistantName(busAssistants, id)}]`;
        }) || ""
      } \n` +
      `Bus: ${
        route.vehicleId ? getVehiclePlateNumber(vehicles, route.vehicleId) : "-"
      },${
        route.backupVehicles.map((id: any) => {
          return ` [${getVehiclePlateNumber(vehicles, id)}]`;
        }) || ""
      } \n\n`;

    const studentData = processRoutesToRemoveSchoolLocation(
      [route],
      busSchedule.type,
    )[0].routeLocations.map((item: any) => {
      return (
        `${moment(item.arrivedAt, "HH:mm").format("HH:mm")}\n` +
        `${item.order}. ${item.blockNumber} ${item.street} ${item.postalCode}\n` +
        `${item.remark !== null ? `${item.remark}\n` : ""}` +
        `${item.students
          .sort((a: any, b: any) => a.id - b.id)
          .map((data: any) => {
            return `${data.locationCode} - ${data.firstName} ${data.lastName}\n`;
          })
          .join("")} \n`
      );
    });

    if (busSchedule.type === "to_school") {
      navigator.clipboard.writeText(
        `${waveData + driverData + studentData.join("") + schoolData}`,
      );
    } else {
      navigator.clipboard.writeText(
        `${waveData + driverData + schoolData + studentData.join("")}`,
      );
    }

    notify("Text copied to clipboard");
  };

  return (
    <Button
      label="Copy Route in Text"
      onClick={() => {
        handleCopyToClipboard(selectedData);
      }}
    />
  );
};

export default CopyRouteInTextButton;
